import { PayrollCycle } from "services/PayrollCycle";

export interface PATemplate {
  id: string;
  createdAt: string;
  status: number;
  orgId: number;
  code: string;
  name: string;
  nativeName: string;
  description: string;
  nativeDescription: string;
  fromCycle: number;
  toCycle: number;
  cutOffDate: number;
  fromPayDate: number;
  toPayDate: number;
  workDays: number;
  notifyUsers?: { fullName: string; code: string; id: number }[];
  productivityTemplateFields: PATemplateField[];
  productivityTemplatePeriods?: {
    status?: number;
    period: number;
    from: number;
    to: number;
    id: string;
  }[];

  payrollCycleIds?: string[];
  payrollCycles?: PayrollCycle[];
  productivityTemplateCycles: PayrollCycleParent[];
}

interface PayrollCycleParent {
  id: string;
  payrollCycle: {
    id: string;
    status: number;
    type: string;
    period: number;
    from: number;
    to: number;
    cutOffDate: number;
    fromPayDate: number;
    toPayDate: number;
    payDate: null;
    isPayDateNextCycle: boolean;
  };
}

export interface PATemplateDetail {
  id: string;
  createdAt: string;
  status: number;
  orgId: number;
  code: string;
  name: string;
  nativeName: string;
  description: string;
  nativeDescription: string;
  fromCycle: number;
  toCycle: number;
  cutOffDate: number;
  fromPayDate: number;
  toPayDate: number;
  workDays: number;
  type: string;
  notifyUsers?: { fullName: string; code: string; id: number }[];
  productivityTemplatePics?: {
    employeeFullName: string;
    employeeCode: string;
    id: number;
  }[];
  productivityTemplateFields: PATemplateField[];
  productivityTemplatePeriods: {
    status?: number;
    period: number;
    from: number;
    to: number;
  }[];
  groupDataDistinct: {
    templateId: string;
    groupData: string;
    groupDataIndex: number;
    children?: PATemplateField[];
  }[];
  productivityTemplateGroupFields: {
    id: string;
    status: number;
    code: string;
    columnName: string;
    columnNativeName: string;
    index: number;
    field: string;
    productivityTemplateFields: PATemplateField[];
  }[];

  payrollCycleIds?: string[];
  payrollCycles?: PayrollCycle[];
  templatePayrollCycles?: {
    id: string;
    payrollCycle: PayrollCycle;
  }[];
  productivityTemplateCycles?: {
    id: string;
    payrollCycle: PayrollCycle;
  }[];
}

interface PATemplateField {
  id: string;
  status: number;
  index: number;
  type: string;
  fieldId: string;
  code: string;
  columnName: string;
  columnNativeName: string;
  dataType: number;
  formula: Formula;
  groupData: string;
  groupDataIndex: null;
  field: Field;
}

interface Field {
  id: string;
  code: string;
  name: string;
  nativeName: string;
  formula: Formula;
  index: number;
}

interface Formula {
  pattern: string;
}

export interface PATemplateListRequest {
  page?: number;
  limit?: number;
  status?: number | null;
  name?: string;
  pics?: string[] | null;
  keyword?: string;
}

export interface PATemplateCreateRequest {
  code: string;
  name: string;
  nativeName: string;
  description: string;
  nativeDescription: string;
  workDays?: number;
  status: number;
  type: string;
  productivityTemplatePics: string[];
  productivityTemplatePeriods?: {
    period: number;
    from: number;
    to: number;
    cutOffDate: number;
    fromPayDate: number;
    toPayDate: number;
  }[];
  templatePeriods?: {
    period: number;
    from: number;
    to: number;
    cutOffDate: number;
    fromPayDate: number;
    toPayDate: number;
  }[];
  payrollCycleIds?: string[];
}

export interface PATemplateUpdateRequest extends PATemplateCreateRequest {
  id: string;
}

export interface PATemplateListResponse extends RestAPIMetaResponse {
  items: Array<PATemplate>;
}

export enum PATemplateUnit {
  Day = 1,
  Month = 3,
}

export interface PATemplateFieldCreateRequest {
  templateId: string;
  items: Item[];
  status: number;
}

interface Item {
  index: number;
  fieldId: string;
  columnName: string;
  dataType: number;
  formula: Formula;
}

interface Formula {
  pattern: string;
}

export interface PATemplateFieldUpdateRequest
  extends PATemplateFieldCreateRequest {
  id: string;
}

export enum PATemplateFieldType {
  SYSTEM = "SYSTEM",
  CUSTOM = "CUSTOM",
}

export interface PAPrintTemplate {
  id: string;
  createdAt: string;
  updatedAt: string;
  deletedAt: null;
  status: number;
  createdBy: CreatedBy;
  updatedBy: CreatedBy;
  ownerList: null;
  name: string;
  nativeName: string;
  description: string;
  nativeDescription: string;
  fileName: string;
  orgId: number;
  templateId: string;
  groupBy?: string;
}

interface CreatedBy {
  userId: number;
  fullName: string;
  employeeId: number;
}
